import React from 'react';
import { Flex, P } from '@tpr/core';
import { ArrowUp, ArrowDown } from '@tpr/icons';
import styles from './button.module.scss';
export var UnderlinedButton = function (_a) {
    var children = _a.children, isOpen = _a.isOpen, onClick = _a.onClick, tabIndex = _a.tabIndex;
    if (typeof onClick === 'undefined') {
        return (React.createElement("div", { className: styles.buttonPlaceholder },
            React.createElement(Flex, { cfg: { flex: '0 0 auto', alignItems: 'center' } },
                React.createElement(P, { cfg: { fontSize: 2, fontWeight: 3 } }, children))));
    }
    return (React.createElement("button", { className: styles.button, onClick: onClick, "aria-expanded": isOpen, tabIndex: tabIndex },
        React.createElement(Flex, { cfg: { flex: '0 0 auto', alignItems: 'center' } },
            React.createElement(P, { cfg: { fontSize: 2, fontWeight: 3 } }, children),
            isOpen ? (React.createElement(ArrowUp, { width: "24px", fill: styles.arrowColor })) : (React.createElement(ArrowDown, { width: "24px", fill: styles.arrowColor })))));
};
//# sourceMappingURL=button.js.map